/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { environment } from "environments/environment";

// for development and test environments, log the invalid fields to the console
// intended to help with debugging when a field is invalid but the form is not showing the error
// or the field failing validation or the message is hidden from the user
export function logValidationErrorsForDevAndTest(dataForm): void {
    var isDev = environment.name === 'DEV';
    var isTest = environment.name === 'TEST';
    if (isDev || isTest) {
        Object.keys(dataForm.controls)?.forEach(key => {
            if (dataForm.controls[key].invalid) {
                console.log(key + ' is invalid');
            }
        });

        if (dataForm.errors) {
            Object.keys(dataForm.errors)?.forEach(key => {
            console.log(key + ' is invalid');
            });
        }
    }
}